<template>
  <div id="app">
    <router-view class="h-screen antialiased" />
    <notifications position="top right" :speed="500" class="mt-16" />
  </div>
</template>
<script>
export default {};
</script>
<style src="@/assets/css/tailwind.css"></style>
